const preventEnterDirective = function () {
    return {
        link: function (scope, element) {
            $(element).keypress(function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }

                return true;
            });
        },
    };
};

module.exports = preventEnterDirective;
